module.exports = __webpack_public_path__ + "img/pd-img-head11.28a5b7c6.png";